import React from "react";
import "./AboutText.css";

// Renders the CMS about text: a blank line starts a new paragraph, a single
// line break stays a line break.
export default function AboutText({ text, className = "" }) {
  const paragraphs = (text || "")
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className={`about-text ${className}`.trim()}>
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  );
}
